import _ from 'lodash';
import actionTypes from '../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CONFIG_SUCCESS: {
      return _.cloneDeep(action.config);
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/config.reducer.js